import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import Cache from 'utils/cache';

const initialState = {
    isAuthenticated: true,
    authToken: null,
    isLoading: true,
    firebaseAuth: null,
    logOut: () => {},
};

const AuthContext = React.createContext(initialState);

const AuthProvider = ({children}) => {
    const auth = firebase.auth();
    const history = useHistory();

    const [authToken, setAuthToken] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(authToken);
    const [firebaseAuth, setFirebaseAuth] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const onIdTokenChanged = firebaseAuth => {
        if (firebaseAuth) {
            setFirebaseAuth(firebaseAuth);
            setIsLoading(true);
            firebaseAuth
                .getIdToken()
                .then(token => {
                    // possible test tokens are 'no_user_on_test_list', 'no_user_email_not_verified', 'user_exists_no_profile' and 'user_exists'
                    // const testtoken = 'no_user_email_not_verified';
                    setAuthToken(token);
                    setIsAuthenticated(!!token);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error(error);
                    setAuthToken(null);
                    setIsAuthenticated(false);
                    setIsLoading(false);
                });
        } else {
            setIsAuthenticated(false);
            setAuthToken(null);
            setIsLoading(false);
            // setFirebaseAuth(null);
        }
    };

    const updateCurrentUser = () => auth.updateCurrentUser();

    const sendVerificationEmail = () => {
        auth.currentUser
            .sendEmailVerification()
            .then(() => {
                // email sent
            })
            .catch(error => {
                console.error(error);
            });
    };

    const logOut = () => {
        Cache.clearStore();
        setIsLoading(true);
        auth.signOut();
        setFirebaseAuth(null);
        setIsLoading(false);
        window.location.hostname.match(/app.mmseas.com/i)
            ? (window.location.href = '//www.mmseas.com/')
            : history.push('/');
    };

    useEffect(() => {
        const unsub = auth.onIdTokenChanged(onIdTokenChanged);
        return () => {
            unsub();
        };
    }, [auth]);

    return (
        <AuthContext.Provider
            displayName='Auth'
            value={{
                ...initialState,
                isAuthenticated,
                isLoading,
                // isOnboarded,
                authToken,
                logOut,
                firebaseAuth,
                sendVerificationEmail,
                updateCurrentUser,
                // can remove below after testing
                setAuthToken,
                setIsAuthenticated,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
export {AuthContext};
